import { render, staticRenderFns } from "./mypage-top-component.vue?vue&type=template&id=34e3961b&"
import script from "./mypage-top-component.vue?vue&type=script&lang=js&"
export * from "./mypage-top-component.vue?vue&type=script&lang=js&"
import style0 from "./mypage-top-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports